import { msg, msgSet } from "./i18n/messages"

/// <reference path="./i18n/providers.ts" />

export const str = {

    Ok: "Ok",
    Cancel: "Cancel",
    Create: "Create",
    Update: "Update",
    Edit: "Edit",
    Ignore: "Ignore",
    Delete: "Delete",
    Zoom: "Zoom",
    Options: "Options",
    Export: "Export",
    Yes: "Yes",
    No: "No",

    Errors: "Errors",
    Error: "Error",
    Warning: "Warning",

    Holding: "Holding",
    Field: "Field",
    Fields: "Fields",
    FieldGroup: "Field group",
    Cropping: "Cropping",
    CroppingPlural: "Cropping",

    Layer: "Layer",
    Layers: "Layers",
    MapLayers: "Map Layers",

    Plans: "Plans",
    Boundaries: "Boundaries",
    YieldMaps: "Yield Maps",

    Year: "Year",
    Date: "Date",

    Crop: "Crop",

    SoilAnalysis: "Soil analysis",

    None: "None",

    NoCrop: "(No crop)",
    NoYear: "(No year)",
    NoDate: "(No date)",
    NoFieldGroup: "(No field group)",
    NotSet: "(Not set)",

    GroupByCrop: "Group by crop",
    GroupByVariety: "Group by variety",
    GroupByField: "Group by field",
    GroupByFieldGroup: "Group by field group",
    GroupByDate: "Group by date",

    White: "White",

    Modules: {
        Dashboard: "Dashboard",
        Fields: "Fields",
        MapLayers: "Map layers",
        Stocks: "Stocks",
        Data: "Data",
        Export: "Export",
        Import: "Import",
        Reports: "Reports",
        Reports2: "Reports2",
    } as const,

    Entities: {
        PcnAnalysis: "PCN analysis",
        HSA: "Healthy soil assessment",
        HSAPlural: "Healthy soil assessments",
        NAnalysis: "Nitrogen analysis",
        FieldPerf: "Field performance",
    } as const,


    get Uncropped() { return msg("Uncropped") },

} as const


export const moduleNames = msgSet({
    Dashboard: "Dashboard",
    Fields: "Fields",
    MapLayers: "Map layers",
    Stocks: "Stocks",
    Data: "Data",
    Export: "Export",
    Import: "Import",
    Reports: "Reports",
}, "Module name")
